import React from "react";
import { useLocation } from "react-router-dom";
import DashboardNav from "./Dashboard_Nav";

const Nav = ({ onToggleSidebar }) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return <>{isDashboard && <DashboardNav onToggleSidebar={onToggleSidebar} />}</>;
};

export default Nav;
